import { render, staticRenderFns } from "./SelectedInstrumentsReview.vue?vue&type=template&id=454c86a0&scoped=true"
import script from "./SelectedInstrumentsReview.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectedInstrumentsReview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SelectedInstrumentsReview.vue?vue&type=style&index=0&id=454c86a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454c86a0",
  null
  
)

export default component.exports